













import Vue from 'vue'

type DataType = {
  listValue: string[]
}

export default Vue.extend({
  name: 'VideoListPage',
  data(): DataType {
    return {
      listValue: ['sample.json'],
    }
  },
})
